// extracted by mini-css-extract-plugin
module.exports = {"container_pagination":"Pagination_container_pagination__3Vqn-","active":"Pagination_active__1R0gI"};